module.exports = __webpack_public_path__ + "static/media/shareLockGuide4.d3882e88.png";